import { ColorIconHelper, localForageHelper, onUserChange, SocialNetworksAvailables, User } from '@/hub-shared'
import { FacebookDiscoveryUser, Identity } from '@/interfaces/user.interface'
import defaultImage from '@assets/img/jpg/avatar.jpg'
import { useEffect, useMemo, useState } from 'react'
import { SubscriptionLike } from 'rxjs'
import { ProfileBinded } from '../../../success-vinculate/success-vinculate.component'

import './header.component.scoped.scss'

type Props = {
  profileBinded?: ProfileBinded
  socialNetwork: SocialNetworksAvailables
}

export default ({ profileBinded, socialNetwork }: Props) => {
  const colorIconHelper = useMemo(() => new ColorIconHelper(), [])
  const [profileSelected, setProfileSelected] = useState<FacebookDiscoveryUser | null>(null)
  const [user, setUser] = useState<User | null>(null)
  const network = useMemo(() => (socialNetwork === 'facebook' ? 'instagram' : socialNetwork), [socialNetwork])

  useEffect(() => {
    const checkBusinessProfileSelected = async () => {
      const businessProfileSelected = (await localForageHelper.getItem('businessProfileSelected')) as FacebookDiscoveryUser
      if (businessProfileSelected) {
        setProfileSelected(businessProfileSelected)
      }
    }

    checkBusinessProfileSelected()
  }, [])

  useEffect(() => {
    if (user) {
      const getProfileFromIdentites = (idProfile: string) => {
        return user.identities.find((identity) => identity.id === idProfile)
      }

      const parseIdentityToProfileFound = (identity: Identity): FacebookDiscoveryUser => ({
        id: identity.id,
        name: identity?.name,
        username: identity?.username,
        profile_picture_url: identity?.picture,
      })

      const checkIfProfileIsRenewed = async () => {
        const idProfileRenewed = (await localForageHelper.getItem('idProfileRenewed')) as string
        if (idProfileRenewed) {
          const selectedProfile = getProfileFromIdentites(idProfileRenewed)
          if (selectedProfile) {
            setProfileSelected(parseIdentityToProfileFound(selectedProfile))
          }
        }
      }

      const checkProfileAdded = async () => {
        setProfileSelected({
          id: profileBinded?.id,
          name: '',
          username: profileBinded?.username,
          profile_picture_url: profileBinded?.picture,
        })
      }

      if (profileBinded) {
        checkProfileAdded()
      } else {
        checkIfProfileIsRenewed()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    const userChangedSubscription: SubscriptionLike = onUserChange?.subscribe((user) => {
      if (user) {
        setUser(user)
      }
    })

    return () => userChangedSubscription.unsubscribe()
  }, [])

  return profileSelected ? (
    <div className="header-actions display-flex justify-content-space-between">
      <div className="page-and-profile">
        {network === 'instagram' ? (
          <div className="icon-page">
            <img width="100%" src={defaultImage} alt="Page" />
            <div className="icon-facebook-page background-facebook">
              <i className="fa-brands fa-facebook"></i>
            </div>
          </div>
        ) : null}
        <div className="icon-profile">
          <img
            src={profileSelected?.profile_picture_url}
            alt="Profile"
            width="100%"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = defaultImage
            }}
          />
          <div className={`icon-instagram-profile background-${colorIconHelper.setColor(network)}`}>
            <i className={`fa-brands fa-${colorIconHelper.setIcon(network)}`}></i>
          </div>
        </div>
      </div>
      <div className="infos-connection">
        <p className="page-name">{profileSelected?.name}</p>
        <p className="h6 m-0 username">@{profileSelected?.username}</p>
      </div>
    </div>
  ) : null
}
